import { render, staticRenderFns } from "./fireFacilitiesManage.vue?vue&type=template&id=bf063034&"
import script from "./fireFacilitiesManage.vue?vue&type=script&lang=js&"
export * from "./fireFacilitiesManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports